import list from './list'
import icon from '@mui/icons-material/Insights';

const adminConfig = { list, icon };

export default adminConfig;
